import * as React from 'react';
import SkipLink from '../SkipLink/SkipLink';
import S from './SectionWrapper.styles';
export var BackgroundVariant;
(function (BackgroundVariant) {
    BackgroundVariant["AccountBlue"] = "account-blue";
    BackgroundVariant["Blue"] = "blue-dark";
    BackgroundVariant["Grey"] = "grey";
    BackgroundVariant["Purple"] = "purple-light";
    BackgroundVariant["PurpleDark"] = "purple-dark";
    BackgroundVariant["White"] = "white";
})(BackgroundVariant || (BackgroundVariant = {}));
const SectionWrapper = React.forwardRef((props, ref) => {
    const { id, children, layout = 'default', flush = 'none', variant, removeSkipLink, skipLinkType, translations, ...otherProps } = props;
    return (React.createElement(S.Container, { ref: ref, id: id, "data-flush": flush, "data-variant": variant !== BackgroundVariant.White ? variant : undefined, ...otherProps },
        !removeSkipLink ? (React.createElement(SkipLink, { type: skipLinkType, translations: translations })) : (React.createElement(S.FocusAnchor, { "aria-label": translations?.['global.skip.anchor'] })),
        renderLayout()));
    function renderLayout() {
        if (layout === 'fullWidth') {
            return children;
        }
        return React.createElement(S.Inner, null, children);
    }
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
